import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'frmg-password-created',
  templateUrl: './password-created.component.html',
  styleUrls: ['./password-created.component.scss'],
  imports: [MatButton]
})
export class PasswordCreatedComponent {
  @Input() reset: boolean = false;
  constructor(
    private router: Router
  ) {

  }

  goToLogin(): void {
    this.router.navigate(['login']);
  }
}
